import dropzone from './dropzone'
import routingModal from './routing-modal'
import resultsModal from './results-modal'
import tncReservations from './tnc-reservations'
import unroutedReservations from './unrouted-reservations'
import driverInbound from './driver-inbound'
import driverOutbound from './driver-outbound'
import driverTncTcp from './driver-tnc-tcp-staging'
import drivers from './drivers'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    dropzone.state,
    routingModal.state,
    resultsModal.state,
    tncReservations.state,
    unroutedReservations.state,
    driverInbound.state,
    driverOutbound.state,
    driverTncTcp.state,
    drivers.state
  ),
  mutations: Object.assign(
    dropzone.mutations,
    routingModal.mutations,
    resultsModal.mutations,
    tncReservations.mutations,
    unroutedReservations.mutations,
    driverInbound.mutations,
    driverOutbound.mutations,
    driverTncTcp.mutations,
    drivers.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/laxit/index.js